// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".main." + {"354":"39ccb0cf","418":"85b7f3b1","661":"6839f3af"}[chunkId] + ".js";
};